import React from "react";
import PropTypes from "prop-types";
import CardClass from "../../CardClass";
import { green } from "@mui/material/colors";
import Table from "../../Table";
import BaseUnit from "../../../Utility/Crud/BaseUnit";
import Vendor from "../../../Utility/Crud/Vendor";
import ProductType from "../../../Utility/Crud/ProductType";
import BaseUnitType from "../../../Utility/Crud/BaseUnitType";
import MainContext from "../../../Context/MainContext/MainContext";

export default class CardApprovalApprovedEquipment extends CardClass {
  static contextType = MainContext; // For legacy class components

  /**
   * Render the content of the card.
   */
  renderContent() {
    const filteredApprovedProducts = this.props.products.filter(
      (product) => product.approved === true,
    );
    filteredApprovedProducts.map((product) => {
      product.hasUpgrade = this.props.products.some(
        (p) => p.upgradedFromProductId === product.id,
      );

      if (product.baseUnitId) {
        const baseUnit = this.context.baseUnitsIndexed[product.baseUnitId];
        const vendorName = Vendor.getDisplayName(
          this.context.vendorsIndexed[baseUnit.vendorId],
        );
        const baseUnitName = BaseUnit.getDisplayName(
          this.context.baseUnitsIndexed[product.baseUnitId],
        );
        product.productSubTypeName = `${vendorName} ${baseUnitName}`;
        product.category = BaseUnitType.getDisplayName(
          this.context.baseUnitTypesIndexed[baseUnit.baseUnitTypeId],
        );
      } else {
        product.category = ProductType.getDisplayName(
          this.context.productTypesIndexed[product.productTypeId],
        );
        product.productSubTypeName =
          product.productSubTypeId &&
          this.context.productSubTypesIndexed[product.productSubTypeId]
            ? this.context.productSubTypesIndexed[product.productSubTypeId].name
            : null;
      }
    });
    return (
      <Table
        columns={[
          {
            key: "hasUpgrade",
            name: "",
            type: "boolean",
            icon: "Upgrade",
            color: "primary.main",
            width: "10",
            tooltip: "Has Upgrade",
          },
          {
            key: "deliverable",
            name: "",
            type: "boolean",
            icon: "LocalShipping",
            color: "info.main",
            width: "10",
            tooltip: "Deliverable",
          },
          {
            key: "billable",
            name: "",
            type: "boolean",
            icon: "RequestQuote",
            color: "success.main",
            width: "10",
            tooltip: "Billable",
          },
          { key: "category", name: "Category", type: "string", width: "150" },
          {
            key: "productSubTypeName",
            name: "Product",
            type: "string",
            width: "200",
          },
          { key: "serial", name: "Serial", type: "string", width: "150" },
          {
            key: "warranty",
            name: "Warranty",
            type: "boolean",
            icon: "Check",
            color: green[500],
            width: "100",
          },
          {
            key: "abnRequired",
            name: "ABN",
            type: "boolean",
            icon: "Check",
            color: green[500],
            width: "100",
          },
          {
            key: "delivered",
            name: "Delivered",
            type: "boolean",
            icon: "Check",
            color: green[500],
            width: "100",
          },
        ]}
        rows={filteredApprovedProducts}
      />
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Approved Equipment";
  }

  /**
   * @returns {string} The minHeight of the card.
   */
  getMinHeight() {
    return "100%";
  }
}
